export const RECORDER_DRAFT_ITEM_ID = 123456789123;

